import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function editSaleData(data, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.editSaleData({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        body: data
    })
}

export function editSaleDataNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.editSaleData"),
        message: i18n.t("apiNotifications.editSaleDataSuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function editSaleDataNotificationFailure(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.editSaleData"),
        message: i18n.t("apiNotifications.editSaleDataFailure"),
        status: 'error',
        dismissible: true,
        dismissAfter: 15000
    }))
}
